import { Button, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslate } from 'react-admin';

import { InfoBox } from './InfoBox';

type T1FilterValue = boolean | null;

interface T1FilterProps {
  value: T1FilterValue;
  onChange: (value: T1FilterValue) => void;
}

export const T1Filter: React.FC<T1FilterProps> = ({
  value,
  onChange
}) => {
  const translate = useTranslate();
  return (
    <InfoBox title={translate('osfc.storage_ui.t1_filter.title')} style={{ marginBottom: '15px' }}>
      <Typography component="p" variant="body2" style={{ margin: '0 0 8px 0' }}><strong>{translate('osfc.storage_ui.t1_filter.show_pallets')}</strong></Typography>
      <div style={{ margin: '10px 0', display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
        <Button
          onClick={() => onChange(null)}
          variant={value === null ? 'contained' : 'outlined'}
          color="secondary"
          size="small"
          style={{ minWidth: '50px', padding: '5px 10px' }}
        >
          {translate('osfc.storage_ui.t1_filter.all')}
        </Button>
        <Button
          onClick={() => onChange(true)}
          variant={value === true ? 'contained' : 'outlined'}
          color="secondary"
          size="small"
          style={{ minWidth: '50px', padding: '5px 10px' }}
        >
          {translate('osfc.storage_ui.t1_filter.t1')}
        </Button>
        <Button
          onClick={() => onChange(false)}
          variant={value === false ? 'contained' : 'outlined'}
          color="secondary"
          size="small"
          style={{ minWidth: '50px', padding: '5px 10px' }}
        >
          {translate('osfc.storage_ui.t1_filter.non_t1')}
        </Button>
      </div>
    </InfoBox>
  );
};

export type { T1FilterValue };
